import React from "react";

export default function PlaylistCardLoader({ dark = true }) {
  return (
    <div
      className={`rounded-2xl overflow-hidden border animate-pulse flex flex-col ${
        dark
          ? "bg-zinc-900/40 border-zinc-800/60"
          : "bg-white border-zinc-200"
      }`}
    >
      <div className="aspect-square w-full bg-zinc-800/60 p-4">
        <div className="w-full h-full rounded-xl bg-zinc-800/80"></div>
      </div>
      <div className="p-4 flex flex-col gap-2">
        <div className="h-3 w-20 bg-zinc-800 rounded-full"></div>
        <div className="h-5 w-3/4 bg-zinc-800 rounded-md"></div>
        <div className="h-3 w-full bg-zinc-800/60 rounded"></div>
        <div className="h-3 w-2/3 bg-zinc-800/60 rounded"></div>
        <div className="mt-2 pt-2 border-t border-zinc-800/50 flex justify-between">
          <div className="h-3 w-16 bg-zinc-800/40 rounded"></div>
          <div className="h-3 w-16 bg-zinc-800/40 rounded"></div>
        </div>
      </div>
    </div>
  );
}
